<template>
    <a-form class="session-form" :form="form">
        <a-row :gutter="[15, 0]">
            <a-col :span="12">
                <!-- 日期 -->
                <a-form-item style="width: 100%" :label="$t('program.batch_live_label_date' /* 日期 */)">
                    <a-select
                        style="width: 100%"
                        :placeholder="$t('formConfig.please_select' /* 请选择 */) + $t('program.batch_live_label_date')"
                        v-decorator="['date_id', { rules: [{ required: true, message: $t('formConfig.please_select' /* 请选择 */) + $t('program.batch_live_label_date') }] }]"
                        allowClear
                    >
                        <a-select-option v-for="item in dateList" :key="item.id" :value="item.id">
                            {{ item.meeting_date }}
                        </a-select-option>
                    </a-select>
                </a-form-item>
            </a-col>
            <a-col :span="12">
                <!-- 会场 -->
                <a-form-item style="width: 100%" :label="$t('program.batch_live_label_hall' /* 会场 */)">
                    <a-select
                        style="width: 100%"
                        :placeholder="$t('formConfig.please_select' /* 请选择 */) + $t('program.batch_live_label_hall')"
                        v-decorator="['hall_id', { rules: [{ required: true, message: $t('formConfig.please_select' /* 请选择 */) + $t('program.batch_live_label_hall') }] }]"
                        allowClear
                    >
                        <a-select-option v-for="item in hallList" :key="item.id" :value="item.id">
                            {{ item.meeting_hall }}
                        </a-select-option>
                    </a-select>
                </a-form-item>
            </a-col>
            <a-col :span="24">
                <!-- Session -->
                <a-form-item style="width: 100%" label="Session">
                    <a-select
                        style="width: 100%"
                        :placeholder="$t('formConfig.please_select' /* 请选择 */) + 'Session'"
                        v-decorator="['parent_id', { rules: [{ required: true, message: $t('formConfig.please_select' /* 请选择 */) + 'Session' }] }]"
                    >
                        <a-select-option v-for="item in sessionList" :key="item.id" :value="item.id">
                            {{ `${item.starttime_slot}-${item.endtime_slot} ${item.abstract_title}` }}
                        </a-select-option>
                    </a-select>
                </a-form-item>
            </a-col>
            <a-col :span="8">
                <!-- 时段 -->
                <a-form-item style="width: 100%" :label="$t('program.start_time_placeholder') /* 开始时间 */">
                    <a-time-picker
                        style="width: 100%"
                        :placeholder="$t('program.start_time_placeholder' /* 开始时间 */)"
                        v-decorator="['starttime_slot', { rules: [{ required: true, message: $t('program.start_time_placeholder' /* 开始时间 */) }] }]"
                        @change="handleStartTimeChange"
                        format="HH:mm"
                    />
                </a-form-item>
            </a-col>
            <a-col :span="8">
                <a-form-item :label="$t('program.end_time_placeholder' /* 结束时间 */)" class="mb10 flex-item" :wrapper-col="{ span: 24 }">
                    <a-time-picker
                        style="width: 100%"
                        :placeholder="$t('program.end_time_placeholder' /* 结束时间 */)"
                        v-decorator="['endtime_slot', { rules: [{ required: true, message: $t('program.end_time_placeholder' /* 结束时间 */) }] }]"
                        @change="handleEndTimeChange"
                        :disabledHours="disabledHours"
                        :disabledMinutes="disabledMinutes"
                        format="HH:mm"
                    />
                </a-form-item>
            </a-col>

            <a-col :span="8">
                <a-form-item class="mb10 flex-item" :label="$t('program.duration_minutes') /* 时长分钟 */">
                    <a-input-number
                        style="width: 100%"
                        :placeholder="$t('program.p_duration_minutes') /* 请输入时长 */"
                        v-decorator="['timelength', { rules: [{ required: true, message: $t('program.p_duration_minutes') /* 请输入时长 */ }] }]"
                    ></a-input-number>
                </a-form-item>
            </a-col>
            <a-col :span="24">
                <a-form-item style="width: 100%" class="mb10" :label="$t('program.sorting') /* 排序 */">
                    <a-input-number
                        style="width: 100%"
                        :placeholder="$t('program.hall_sorting_placeholder') /* 请填写排序 */"
                        v-decorator="['orderbyid', { initialValue: 0, rules: [{ required: true, message: $t('program.hall_sorting_placeholder') /* 请填写排序 */ }] }]"
                    ></a-input-number>
                    <template slot="extra">
                        <p style="color: red">{{ $t('program.sorting_tip') /* 序号越小越靠前 */ }}</p>
                    </template>
                </a-form-item>
            </a-col>
            <a-col :span="24" v-if="is_teaching_form">
                <a-form-item style="width: 100%" class="mb10" :label="$t('program.meeting_type')">
                    <a-radio-group v-decorator="['teaching_form', { rules: [{ required: true, message: $t('program.p_meeting_type') /* '请选择会议形式' */ }] }]">
                        <a-radio :value="1">{{ $t('program.meeting_type1') /* 录播 */ }}</a-radio>
                        <a-radio :value="2">{{ $t('program.meeting_type2') /* 线上连接 */ }}</a-radio>
                        <a-radio :value="3">{{ $t('program.meeting_type3') /* 现场参会 */ }}</a-radio>
                        <a-radio :value="0">{{ $t('program.meeting_type4') /* 未确定 */ }}</a-radio>
                    </a-radio-group>
                </a-form-item>
            </a-col>
            <a-col :span="24" v-if="is_teaching_form && form.getFieldValue('teaching_form') == 2">
                <a-form-item :label="$t('program.add_task.live_streaming_link') /* 直播链接 */">
                    <a-input v-decorator="['zoom_url', { rules: [{ required: true, message: $t('program.add_task.live_streaming_link') /* 直播链接 */ }] }]"></a-input>
                </a-form-item>
            </a-col>
        </a-row>
    </a-form>
</template>
<script>
const fileds = ['date_id', 'hall_id', 'parent_id', 'starttime_slot', 'endtime_slot', 'timelength', 'orderbyid', 'teaching_form', 'zoom_url'];
import moment from 'moment'
import pick from 'lodash.pick'
export default {
    name: 'dateHallForm',
    props: {
        is_type: {
            // 添加还是编辑
            default: 'add',
            type: String
        },
        sessionInfo: {
            // sessionInfo
            default: () => {},
            type: Object
        },
        sessionList: {
            // session列表
            default: () => [],
            type: Array
        },
        hallList: {
            // 会场列表
            default: () => [],
            type: Array
        },
        dateList: {
            // 日期列表
            default: () => [],
            type: Array
        },
        is_teaching_form: {
            // 是否显示会议形式
            default: true,
            type: Boolean
        },
        isSub: {
            default: false,
            type: Boolean
        }
    },
    data() {
        return {
            form: this.$form.createForm(this)
        };
    },
    computed: {},
    watch: {
        sessionInfo: {
            handler(newVal) {
                this.$nextTick(() => {
                    this.form.setFieldsValue(pick(newVal, fileds));
                    if (!this.isSub) {
                        this.form.setFieldsValue({ parent_id: this.sessionInfo.session_id });
                    }
                    if (this.sessionInfo.program_list.length > 0 && this.is_type == 'add') {
                        let starttime_slot = this.sessionInfo.program_list[this.sessionInfo.program_list.length - 1].endtime_slot;
                        let endtime_slot = moment(starttime_slot).add(this.sessionInfo.timelength, 'minutes');
                        this.setTimesFun(starttime_slot, endtime_slot);
                    } else {
                        this.setTimesFun(this.sessionInfo.starttime_slot, this.sessionInfo.endtime_slot);
                    }
                });
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        reset() {
            this.form.resetFields();
        },
        setTimesFun(starttime_slot, endtime_slot) {
            this.form.setFieldsValue({ starttime_slot: moment(starttime_slot, 'HH:mm') });
            this.form.setFieldsValue({ endtime_slot: moment(endtime_slot, 'HH:mm') });
        },
        // 结束时间
        handleEndTimeChange(value) {
            let starttime_slot = this.form.getFieldValue('starttime_slot');
            if (starttime_slot) {
                var duration = moment.duration(value.diff(starttime_slot));
                // 获取相差的分钟数
                var timelength = duration.asMinutes();
                this.form.setFieldsValue({ timelength });
            }
        },
        // 禁用小时
        disabledHours() {
            let start_time = this.form.getFieldValue('starttime_slot');
            if (start_time) {
                let start_hour = start_time.hours();
                const hours = [];
                for (let i = 0; i < start_hour; i++) {
                    hours.push(i);
                }
                return hours;
            }
            return [];
        },
        // 禁用分钟
        disabledMinutes(hours, minutes) {
            let start_time = this.form.getFieldValue('starttime_slot');
            if (start_time) {
                let start_hour = start_time.hours();
                if (hours > start_hour) {
                    return [];
                }
                let start_minutes = start_time.minutes();
                const minutes = [];
                for (let i = 0; i < start_minutes; i++) {
                    minutes.push(i);
                }
                return minutes;
            }
            return [];
        },
        // 开始时间
        handleStartTimeChange(value, a) {
            let endtime_slot = moment(value).add(this.form.getFieldValue('timelength'), 'minutes');
            this.form.setFieldsValue({ endtime_slot });
        },
        validate() {
            return new Promise((resolve, reject) => {
                this.form.validateFields((err, values) => {
                    if (!err) {
                        resolve(values);
                    }
                });
            });
        }
    },
    created() {
        fileds.forEach(v => this.form.getFieldDecorator(v));
    },
    mounted() {}
};
</script>
<style lang='less' scoped>
</style>